"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealSummaryLabelType = exports.SAVINGS_REPLACEMENT_WORD = exports.REBATES_REPLACEMENT_WORD = exports.MANUFACTURER_INCENTIVES_TITLE = exports.TEST_DRIVE_SUCCESS_DESCRIPTION = exports.TEST_DRIVE_SUCCESS_TITLE = exports.DEALSTARTER_SIDEBAR_HEADER_TITLE = exports.SUMMARY_SPECIALS_TITLE = exports.DUE_AT_SIGNING_LABEL_DS = exports.CASH_DOWN_LABEL_DS = exports.VEHICLE_PROTECTION_PRICE_TITLE = exports.CREDIT_APP_DESCRIPTION_CREDITOVERWRITEBLOCK_TOGGLE = exports.CREDIT_APP_DESCRIPTION = exports.CREDIT_APP_TITLE = exports.TEST_DRIVE_DESCRIPTION = exports.TEST_DRIVE_TITLE = exports.PROTECT_VEHICLE_SECONDARY_HEADER = exports.PROTECT_VEHICLE_DESCRIPTION = exports.SPECIALS_LINK = exports.DISCLAIMER = exports.TEST_VALUE = exports.DISCOUNT_REPLACE_WORD = exports.ADDITIONAL_DISCOUNTS_TITLE = exports.ADVERTISED_PRICE = exports.CREDIT_NAV_CARD = void 0;
exports.CREDIT_NAV_CARD = 'creditNavigationCard';
exports.ADVERTISED_PRICE = 'advertisedPriceLabel';
exports.ADDITIONAL_DISCOUNTS_TITLE = 'additionalDiscountsTitle';
exports.DISCOUNT_REPLACE_WORD = 'discountReplaceWord';
exports.TEST_VALUE = 'testValue';
exports.DISCLAIMER = 'disclaimer';
exports.SPECIALS_LINK = 'specialsLink';
exports.PROTECT_VEHICLE_DESCRIPTION = 'protectVehicleDescription';
exports.PROTECT_VEHICLE_SECONDARY_HEADER = 'vppSecondaryHeader';
exports.TEST_DRIVE_TITLE = 'testDriveTitle';
exports.TEST_DRIVE_DESCRIPTION = 'testDriveDescription';
exports.CREDIT_APP_TITLE = 'creditAppTitle';
exports.CREDIT_APP_DESCRIPTION = 'creditAppDescription';
exports.CREDIT_APP_DESCRIPTION_CREDITOVERWRITEBLOCK_TOGGLE = 'creditAppOverwriteToggleBlock';
exports.VEHICLE_PROTECTION_PRICE_TITLE = 'vehicleProtectionPricePriceTitle';
exports.CASH_DOWN_LABEL_DS = 'cashDownLabelDS';
exports.DUE_AT_SIGNING_LABEL_DS = 'dueAtSigningLabelDS';
exports.SUMMARY_SPECIALS_TITLE = 'summarySpecialsTitle';
exports.DEALSTARTER_SIDEBAR_HEADER_TITLE = 'dsSidebarHeaderTitle';
exports.TEST_DRIVE_SUCCESS_TITLE = 'testDriveSuccessTitle';
exports.TEST_DRIVE_SUCCESS_DESCRIPTION = 'testDriveSuccessDescription';
exports.MANUFACTURER_INCENTIVES_TITLE = 'manufacturerIncentivesTitle';
exports.REBATES_REPLACEMENT_WORD = 'rebatesReplacementWord';
exports.SAVINGS_REPLACEMENT_WORD = 'savingsReplacementWord';
var DealSummaryLabelType;
(function (DealSummaryLabelType) {
    DealSummaryLabelType["SEPARATOR"] = "separator";
    DealSummaryLabelType["TERM"] = "term";
    DealSummaryLabelType["MSRP"] = "msrp";
    DealSummaryLabelType["MSRP_SHORT"] = "msrpShort";
    DealSummaryLabelType["MSRP_INFO"] = "msrpInfo";
    DealSummaryLabelType["AMT_FINANCED"] = "amountFinanced";
    DealSummaryLabelType["ANNUAL_MILES"] = "annualMiles";
    DealSummaryLabelType["APR"] = "apr";
    DealSummaryLabelType["DMV_FEES"] = "dmvFees";
    DealSummaryLabelType["INCENTIVES"] = "incentivesAmount";
    DealSummaryLabelType["TAXES"] = "taxes";
    DealSummaryLabelType["PRICE"] = "offerPrice";
    DealSummaryLabelType["DUE_AT_SIGNING"] = "dueAtSigning";
    DealSummaryLabelType["TRADE_ALLOWANCE"] = "tradeAllowance";
    DealSummaryLabelType["FIRST_MONTH_PAYMENT"] = "firstMonthPayment";
    DealSummaryLabelType["DOWN_PAYMENT"] = "downPayment";
    DealSummaryLabelType["DOWN_PAYMENT_NEGATIVE"] = "downPaymentNegative";
    DealSummaryLabelType["SECURITY_DEPOSIT"] = "securityDeposit";
    DealSummaryLabelType["NEGATIVE_SIGN"] = "negativeSign";
    DealSummaryLabelType["MANUFACTURER_INCENTIVES_NAME"] = "manufacturerIncentivesName";
})(DealSummaryLabelType = exports.DealSummaryLabelType || (exports.DealSummaryLabelType = {}));
